import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { Platform } from "src/app/models/api";
import { PlatformIconPaths } from "src/app/models/constants/platform.constants";
import { ISelectOption, PlatformSelectOptions } from "src/app/models/selectOptions";
import { ISelectionButton } from "../../selection-button/selection-button.component";

@Component({
    selector: "app-integration-platform-selection",
    templateUrl: "./integration-platform-selection.component.html",
    styleUrls: ["./integration-platform-selection.component.scss"],
})
export class IntegrationPlatformSelectionComponent implements OnInit {
    @Input() public disabled: boolean;
    @Input() public platformFormControl: FormControl<string>;

    public platformsListOptions: ISelectOption[];
    public platformSelectionButtons: BehaviorSubject<BehaviorSubject<ISelectionButton>[]> = new BehaviorSubject<BehaviorSubject<ISelectionButton>[]>(
        [],
    );
    private _platformsForSelectionButtons: string[];
    private _platformIdToDispNameMap: { [id: string]: string | undefined } = {};

    ngOnInit(): void {
        this._platformsForSelectionButtons = this.disabled
            ? PlatformSelectOptions.map((option) => option.id)
            : PlatformSelectOptions.slice(0, 3).map((option) => option.id);
        PlatformSelectOptions.forEach((option) => {
            this._platformIdToDispNameMap[option.value] = option.displayName;
        });
        this.platformsListOptions = PlatformSelectOptions.filter((option) => this._platformsForSelectionButtons.indexOf(<Platform>option.id) < 0);
        this.platformSelectionButtons.next(this._createPlatformSelectionButtons(this.platformFormControl.value));
    }

    public onPlatformSelected(selectedButton: ISelectionButton) {
        this.platformFormControl.setValue(<Platform>selectedButton.id);
    }

    public onMorePlatformSelected(selectionOption: ISelectOption) {
        const selectedIndex = this._platformsForSelectionButtons.indexOf(this.platformFormControl.value);
        this._platformsForSelectionButtons[this._platformsForSelectionButtons.length - 1] = <Platform>selectionOption.id;
        this.platformsListOptions = PlatformSelectOptions.filter((option) => this._platformsForSelectionButtons.indexOf(<Platform>option.id) < 0);

        // if selected platform is going to be replaced with platform from drop down
        // publish platform change
        if (selectedIndex === this._platformsForSelectionButtons.length - 1) {
            this.platformFormControl.reset();
        }

        this.platformSelectionButtons.next(this._createPlatformSelectionButtons(this.platformFormControl.value));
    }

    private _createPlatformSelectionButtons(selectedId: string) {
        const platformSelectionButtons: BehaviorSubject<ISelectionButton>[] = [];
        const selectedIndex = this._platformsForSelectionButtons.indexOf(selectedId);

        this._platformsForSelectionButtons.forEach((platform, index) => {
            const isSelected = selectedIndex === index ? true : false;
            const displayName = this._platformIdToDispNameMap[platform];
            const description = displayName ? displayName : platform;

            if (!this.disabled || isSelected) {
                platformSelectionButtons.push(
                    new BehaviorSubject<ISelectionButton>({
                        id: platform,
                        description: description,
                        iconPath: PlatformIconPaths[platform],
                        selected: isSelected,
                    }),
                );
            }
        });
        return platformSelectionButtons;
    }
}
